export default __webpack_public_path__ + "static/media/Echo-hub.25a985c4.svg";